<template>
  <div>
    <cancel-heading>Are you sure?</cancel-heading>
    <cancel-content>We're sorry ForeFront didn't provide the value you deserve.</cancel-content>
    <cancel-content>Before you close your account, let us know why you're canceling and what we could've done to help you be successful with Forefront.</cancel-content>
    <cancel-content>Our mission is to provide you with simple but powerful tools that help you do more deals. Please let us know what we can do to improve our platform and/or service to help you do more deals.</cancel-content>

    <cancel-box label="If you cancel:">
      <cancel-feature-list/>
    </cancel-box>
  </div>
</template>

<script>
import CancelFeatureList from "./components/CancelFeatureList.vue";
import CancelBox from "./components/CancelBox.vue";
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";

export default {
  name: "AreYouSure",
  components: {CancelContent, CancelHeading, CancelBox, CancelFeatureList}
}
</script>
